<template>
  <div class="menu">
    <img src="./images/top-image.png">
    <div class="ul-box">
      <ul>
        <li :class="{'active': $route.path === '/'}" @click="onRouter('/')">首页</li>
        <li :class="{'active': $route.path === '/orient'}" @click="onRouter('/orient')">儿童定向</li>
        <li :class="{'active': $route.path.indexOf('/dynamic') > -1}" @click="onRouter('/dynamic')">定向动态</li>
        <li :class="{'active': $route.path.indexOf('/game') > -1}" @click="onRouter('/game')">活动赛事</li>
        <li :class="{'active': $route.path.indexOf('/train') > -1}" @click="onRouter('/train')">教研培训</li>
        <li :class="{'active': $route.path.indexOf('/mien') > -1}" class="show_menu_hover" @mouseover="mouseOver"
            @mouseleave="mouseLeave">
          <span>定向风采</span>
          <div class="menu_hover" v-if="onHover" @mouseover="mouseOver">
            <div>
              <p @click="onRouter('/mien/teacher')">教师风采</p>
              <p @click="onRouter('/mien/school')">学校风采</p>
            </div>
          </div>
        </li>
        <li :class="{'active': $route.path.indexOf('/equip') > -1}" @click="onRouter('/equip')">定向装备</li>
        <li :class="{'active': $route.path === '/download'}" @click="onRouter('/download')">定向下载</li>
        <li :class="{'active': $route.path === '/contact'}" @click="onRouter('/contact')">联系我们</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mainMenu',
  components: {},
  data() {
    return {
      onHover: false
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {},
  methods: {
    onRouter(path) {
      this.onHover = false
      if (this.$route.path !== path) {
        this.$router.push({path: path})
      }
    },
    mouseOver() {
      this.onHover = true
    },
    mouseLeave() {
      this.onHover = false
    }
  },
  watch: {}
}
</script>

<style scoped>
.menu {
  width: 100%;
  left: 0;
  top: 0;
  margin: 0 auto;
  margin-bottom: 10px;
}

.menu img {
  width: 100%;
  margin-bottom: 3px;
}

.menu .ul-box {
  width: 100%;
  height: 50px;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("./images/nav-background-image.png");
  background-size: 100%;
}

.menu ul {
  width: 1000px;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.menu ul li {
  width: 87px;
  height: 36px;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  border-radius: 6px;
  position: relative;
}

.menu ul li:nth-child(1) {
  background: linear-gradient(180deg, rgba(130, 83, 156, 1) 0%, rgba(67, 79, 142, 0) 100%);
}

.menu ul li:nth-child(2) {
  background: linear-gradient(180deg, rgba(162, 75, 117, 1) 0%, rgba(109, 70, 137, 0) 100%);
}

.menu ul li:nth-child(3) {
  background: linear-gradient(180deg, rgba(186, 86, 80, 1) 0%, rgba(158, 74, 109, 0) 100%);
}

.menu ul li:nth-child(4) {
  background: linear-gradient(180deg, rgba(224, 107, 36, 1) 0%, rgba(195, 88, 70, 0) 100%);
}

.menu ul li:nth-child(5) {
  background: linear-gradient(180deg, rgba(215, 142, 43, 1) 0%, rgba(226, 105, 35, 0) 100%);
}

.menu ul li:nth-child(6) {
  background: linear-gradient(180deg, rgba(154, 174, 55, 1) 0%, rgba(186, 135, 44, 0) 100%);
}

.menu ul li:nth-child(7) {
  background: linear-gradient(180deg, rgba(106, 187, 57, 1) 0%, rgba(142, 169, 51, 0) 100%);
}

.menu ul li:nth-child(8) {
  background: linear-gradient(180deg, rgba(55, 167, 114, 1) 0%, rgba(95, 174, 74, 0) 100%);
}

.menu ul li:nth-child(9) {
  background: linear-gradient(180deg, rgba(85, 134, 173, 1) 0%, rgba(54, 159, 101, 0) 100%);
}

.menu ul li:hover {
  background: linear-gradient(180deg, rgba(115, 236, 237, 1) 0%, rgba(89, 108, 205, 1) 100%);
}

.menu ul li.active {
  background: linear-gradient(180deg, rgba(115, 236, 237, 1) 0%, rgba(89, 108, 205, 1) 100%);
}

.menu .menu_hover {
  position: absolute;
  top: 36px;
  left: -24px;
  width: 184px;
  height: 108px;
}

.menu .menu_hover > div {
  position: absolute;
  top: 13px;
  left: 0;
  width: 184px;
  height: 88px;
  padding: 20px;
  padding-bottom: 0px;
  background: #FFFFFF;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
  border: 1px solid #E4E7ED;
  border-radius: 6px;
  z-index: 9999;
}

.menu .menu_hover > div:before {
  display: block;
  content: '';
  width: 0px;
  height: 0px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 4px solid #E4E7ED;
  position: absolute;
  top: -4px;
  left: 28px;
}

.menu .menu_hover > div:after {
  display: block;
  content: '';
  width: 0px;
  height: 0px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 4px solid #FFFFFF;
  position: absolute;
  top: -3px;
  left: 28px;
}

.menu .menu_hover > div p {
  font-size: 14px;
  line-height: 14px;
  color: #5A5E66;
  margin-bottom: 20px;
}

.menu .menu_hover > div p:hover {
  color: #76BF28;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/menu.vue